import { DataTable } from "@marketplace/ui/data-table";

import { useAutomationListTableColumns } from "../../hooks/use-automation-list-table-columns";
import type { AutomationListItem } from "../../types";

type AutomationListTableProps = {
  records: AutomationListItem[];
  page: number;
};

export const AutomationListTable: React.FC<AutomationListTableProps> = ({
  records,
  page
}) => {
  const columns = useAutomationListTableColumns(page);

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
